import styled from '@emotion/styled';
import { Icon, Modal, tokens } from '@hotjar/hotsauce';
import type { ModalProps } from '@hotjar/hotsauce';

const arrowButtonSize = tokens.spacer.x8;
const ArrowButton = styled.button<{ position: 'left' | 'right'; largeTopOffset: boolean }>`
  width: ${arrowButtonSize};
  height: ${arrowButtonSize};
  position: absolute;
  top: ${({ largeTopOffset }) => (largeTopOffset ? '300px' : '100px')};

  ${({ position }) =>
    position === 'left'
      ? `left: calc(-${arrowButtonSize} - ${tokens.spacer.x3})`
      : `right: calc(-${arrowButtonSize} - ${tokens.spacer.x3})`};

  background: ${tokens.color.text_light};
  border: none;
  border-radius: ${tokens.radius.m};
  cursor: pointer;
  color: ${tokens.color.text_disabled_inverse};

  &:hover {
    color: ${tokens.color.text_default_inverse};
  }
`;

export interface ResponseModalProps
  extends Pick<ModalProps, 'appElementSelector' | 'children' | 'isOpen' | 'onClose'> {
  onLoadPrevious: () => void;
  onLoadNext: () => void;
  showNextButton: boolean;
  showPreviousButton: boolean;
  largeTopOffset?: boolean;
}

export function ResponseModal({
  children,
  onLoadPrevious,
  onLoadNext,
  showNextButton,
  showPreviousButton,
  largeTopOffset,
  ...props
}: ResponseModalProps): JSX.Element {
  return (
    <Modal contentLabel="Response" {...props}>
      {children}
      {showPreviousButton && (
        <ArrowButton
          largeTopOffset={largeTopOffset === true}
          type="button"
          position="left"
          onClick={onLoadPrevious}
        >
          <Icon icon="arrow_left_alt" description="Previous" size="l" />
        </ArrowButton>
      )}
      {showNextButton && (
        <ArrowButton
          largeTopOffset={largeTopOffset === true}
          type="button"
          position="right"
          onClick={onLoadNext}
        >
          <Icon icon="arrow_right_alt" description="Next" size="l" />
        </ArrowButton>
      )}
    </Modal>
  );
}
